import React from "react";
import { RentReportingConfirmationScreenContainer } from "src/containers";

export const RentReportingConfirmationScreen = () => {
  return <RentReportingConfirmationScreenContainer />;
};
